import { useEffect, useState } from 'react';
import Modal from '../../atoms/modal/view';
import ThirdsTable from '../thirdsTable/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';

function ThirdsModal({ id, type }) {

    const [toogle, setToogle] = useState(false)
    const [loclaType, setType] = useState(type)
    const [initialThirdData, setInitialThirdData] = useState({})

    useEffect(() => {
        listener('toggle-thids-modal', handleToogle)
    }, [])

    function handleToogle(event) {
        const eventData = event.detail?.data || {};
        setType(eventData.type || type)
        setInitialThirdData(eventData.initialThird || {})
        if (!toogle) {
            dispatchCustomEvent('modal' + id, { eventKey: id });
        }
        setToogle(!toogle)
    }

    return (
        <Modal
            id={id}
            width="fit-content"
            style={{ width: '60vw', height: '60vh', maxWidth: '90vw', maxHeight: '85vh', borderRadius: 'var(--radius-lg)', padding: '24px 32px', overflow: 'hidden' }}
        >
            <ThirdsTable
                id={id}
                forceLoadData={true}
                type={loclaType ? loclaType : "client"}
                initialThird={initialThirdData}
            />
        </Modal>
    )
}

export default ThirdsModal
